module.exports = __webpack_public_path__ + "img/no-results.b88bff48.png";